<template>
  <div>
    <b-container class="text-left" v-if="definitionSlug != null">
      <h1 class="text-left mt-2 mb-4">Fogalomtár</h1>
      <h2 class="text-left mt-2 mb-2">{{ definitionSlug.name }}</h2>
      <br />
      <p>{{ definitionSlug.definition }}</p>
      <br />
    </b-container>
  </div>
</template>

<script>
import { getRelatedDefinition } from '../../api/knowledgebase'
export default {
  name: 'DefinitionDetails',
  data() {
    return {
      definitionSlug: null
    }
  },
  async mounted() {
    const definitionSlug = this.$route.params.id

    if (!definitionSlug) this.$router.push('/')
    try {
      this.definitionSlug = await getRelatedDefinition(definitionSlug)
    } catch (error) {
      console.error(error)
    }
  },
  methods: {}
}
</script>

<style scoped>
::v-deep p {
  margin-bottom: 0rem !important;
}

::v-deep .ql-video {
  display: block;
  width: 70%;
  height: 56.25vw;
  max-height: calc(800px / 16 * 9);
}

::v-deep .news-body-content img {
  max-width: 100%;
  width: auto;
  height: auto;
}
</style>
